// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"5437ce83","80":"3fe71c37","288":"ee85e3a6","299":"decb1b85","328":"8ab173da","436":"816e9386","440":"3580e14b","512":"f72e5c74","528":"a1aa3b87","596":"10bf3827","624":"03fa7e80","688":"43206616","924":"2355fd7b"}[chunkId] + ".chunk.js";
};